import { toast, ToasterProps } from 'sonner';

import { UiKitToastBase } from './UiKitToastBase';

interface ToastBaseParams {
  status?: 'success' | 'error';
  position?: ToasterProps['position'];
}

export const toastBase = (
  message: string,
  { status = 'success', position = 'top-right' }: ToastBaseParams = {}
) => {
  toast.custom(
    () => (
      <UiKitToastBase
        message={message}
        status={status}
      />
    ),
    {
      position,
      className:
        'data-[mounted=true]:animate-in data-[mounted=true]:fade-in-0 data-[mounted=true]:slide-in-from-right-full !duration-500'
    }
  );
};
